export const LAFT_HISTORY_ACTIONS = {
  COMPLETAR_POPUP: {
    action: 'Completar LAFT Popup',
    actionDescription: 'User clicks completar the First login LAFT popup',
  },
  COMPLETAR_BANNER: {
    action: 'Completar LAFT banner',
    actionDescription: 'User clicks completar the First login LAFT banner',
  },
  CERRAR_POPUP: {
    action: 'Close LAFT Popup',
    actionDescription: 'User close the First login LAFT popup',
  },
} as const;
